import { createFileRoute } from '@tanstack/react-router'
import { ExtructSimilar } from '@/features/admin/extruct-similar'

export const Route = createFileRoute('/_authenticated/admin/extruct-similar')({
  component: ExtructSimilar,
})
